import { formatClientPrefix } from "../../../../../utils/clientPrefix";

/**
 * The client prefix a project's name starts with, and the rest of the
 * name after it: "CDT-26001-PRO-001" under client CDT splits into "CDT"
 * and "26001-PRO-001". A name that does not start with its client's
 * prefix is left whole, the same way the module headers treat it.
 */
export const plantNameParts = (plant) => {
  const name = plant?.name || "";
  const prefix = formatClientPrefix(plant?.client?.prefix);
  const lead = prefix ? `${prefix}-` : "";

  return lead && name.toLowerCase().startsWith(lead.toLowerCase())
    ? { prefix, number: name.slice(lead.length) }
    : { prefix: "", number: name };
};

/**
 * ", and the 3 WBS under it, with every revision saved under them" -
 * or nothing at all when this plant's WBS have never been loaded (it was
 * never expanded), rather than claiming a count the tree doesn't have.
 */
export const deletePlantWbsCountSuffix = (plant, wbsByPlant) => {
  const wbsList = plant ? wbsByPlant[plant.id] : undefined;
  if (!Array.isArray(wbsList) || wbsList.length === 0) return "";

  return `, and the ${wbsList.length} WBS under it, with every revision saved under them`;
};
